import React from "react";
import MainPresenter from "./MainPresenter";

/**
 * MainContainer
 */
const MainContainer = () => <MainPresenter />;
export default MainContainer;
